import { isNull } from '../utils/utils';

export const moneyFilter = (value: number, displayEmpty = false) => {
    if (isNull(value)) { return '' }

    const empty = displayEmpty ? value : ''

    return value
        ? value
        : empty
}
